import { Component, OnInit, OnDestroy, EventEmitter, Output, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  ApiVisa,
  EmployeeService,
  EntityContainerModel
} from 'blg-akaun-ts-lib';
import { ReplaySubject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { SubSink } from 'subsink2';
import { AppConfig } from '../../shared-utilities/visa';

@Component({
  selector: 'app-sales-man-v1',
  templateUrl: './sales-man.component.html',
  styleUrls: ['./sales-man.component.css']
})
export class SelectAgentDropDownComponent implements OnInit, OnDestroy {

  @Input() salesAgent: FormControl;
  apiVisa = AppConfig.apiVisa;
  @Output() salesAgentChange = new EventEmitter<FormControl>();
  @Output() selectionChange = new EventEmitter();

  private subs = new SubSink();

  filterControl = new FormControl();
  filteredOptions$: ReplaySubject<EntityContainerModel[]> = new ReplaySubject<EntityContainerModel[]>(1);
  entityList: EntityContainerModel[];

  constructor( 
    private employeeService: EmployeeService,
  ) {}

  ngOnInit() {
    this.subs.sink = this.employeeService.get(this.apiVisa).subscribe(
      {next: resolve => {
        this.entityList = resolve.data;
        this.filteredOptions$.next(this.entityList);
      }});
    // if (this.currency.value) {
    //   this.subs.sink = this.currencyService.getByGuid(this.currency.value, this.apiVisa).subscribe( resolved => {
    //     this.branchList = [resolved.data];
    //     this.filteredOptions$.next([resolved.data]);
    //     this.onSelect(resolved.data.bl_fi_mst_branch.guid.toString());
    //   });
    // }
    this.subs.sink = this.filterControl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe({next: resolve => this.filterCurrency(resolve)});
  }

  filterCurrency(search: string) {
    if (!search) {
      this.filteredOptions$.next(this.entityList);
    } else {
      search = search.toLocaleLowerCase();
      const filter = this.entityList.filter(c => c.bl_fi_mst_entity_hdr.name.toLocaleLowerCase().includes(search));
      this.filteredOptions$.next(filter);
    }

  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}

